<template>
	<div id="content">
		<div class="container-fluid">
			<div class="box">
				<div class="row">
					<div class="col">
						<e-select
					        track-by="lieu_id"
							label="lieu_label"
					        v-model="residences_selected"
					        :options="residences"
					        :placeholder="$t('mouvement.rechercher_lieu')"
					        :loading="loading"
					        :sortable="false"
					        :multiple="true"
					    >
					        <template slot="singleLabel" slot-scope="{ option }">{{ option.lieu_label }}</template>
					        <template slot="option" slot-scope="{ option }">{{ option.lieu_label }}</template>
				    	</e-select>
					</div>
					<div class="col">
						<e-select
							v-model="month_selected"
							:placeholder="getTrad('invoice.select_month')"
							:selectedLabel="getTrad('global.selected_label')"
							:options="months"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
						>
							<template slot="option" slot-scope="{ option }">{{ $t('mois.'+option) }}</template>
							<template slot="singleLabel" slot-scope="{ option }">{{ $t('mois.'+option) }}</template>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>

					<div class="col">
						<e-select
							v-model="year_selected"
							:placeholder="getTrad('invoice.select_year')"
							:selectedLabel="getTrad('global.selected_label')"
							:options="years"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
						/>
					</div>
			        <div class="col-2 ml-auto">
			            <button @click="loadStat" class="btn btn-block btn-primary">{{ $t('global.rechercher') }}</button>
			        </div>
				</div>
			</div>
			<div v-if="search" class="box">
				<CustomTable
					id_table="stat_residences"
					primaryKey="horse_id"
					:hrefsRoutes="config_table_hrefs"
					:items="horses"
					:busy.sync="table_busy"
					:columsAddLabel="columsAdd"
				/>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Lieux from '@/mixins/Lieux'

	export default {
		name: 'StatResidence',
		mixins: [Lieux],
		data () {
			return {
				months : Array.from(new Array(12), (x,i) => i+1),
				years: Array.from({ length: 6}, (_, i) => (new Date().getFullYear()-5) + (i * 1)).reverse(), // 5 dernières années,
				month_selected: new Date().getMonth()+1,
				year_selected: new Date().getFullYear(),
				table_busy: false,
				loading: false,
				residences: [],
				residences_selected: [],
				horses: [],
				search: false,
                config_table_hrefs: {
                    'horse_nom': {
                        routeUniqueName: 'horseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                },
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
	            const all_lieux = await this.getLieux(false)
	            this.residences = all_lieux.filter(lieu => lieu.lieu_type == 1 && lieu.lieu_archive == 0)
				this.loading = false
			},

			async loadStat() {
				if(this.residences_selected.length == 0) return false
				this.search = false
				this.$nextTick(() => {
					this.search = true
				})
				this.table_busy = true
				this.horses = await this.getStatResidence(this.residences_selected.map(l => l.lieu_id).join(','), this.month_selected, this.year_selected)
				this.table_busy = false
				this.search = false
				this.$nextTick(() => {
					this.search = true
				})
			}
		},

		computed: {
			columsAdd() {
				return this.residences_selected.map(l => ({key: 'lieu_'+l.lieu_id, label: l.lieu_label}))
			}
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>